import React from 'react';
import { motion } from 'framer-motion';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
import { BoxIcon } from 'lucide-react';
export interface NavTab {
  id: string;
  label: string;
  icon: BoxIcon;
  badge?: number;
}
interface BottomNavProps {
  tabs: NavTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export function BottomNav({
  tabs,
  activeTab,
  onTabChange
}: BottomNavProps) {
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t-2 z-50 md:hidden" style={{
    borderColor: OPENFINANCE_THEME.colors.borderLight,
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.05)'
  }} data-id="element-1565">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2" data-id="element-1566">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="relative flex flex-col items-center justify-center flex-1 h-full transition-colors" style={{
          color: isActive ? OPENFINANCE_THEME.colors.primary500 : OPENFINANCE_THEME.colors.textMuted
        }} data-id="element-1567">
              {/* Active Indicator */}
              {isActive && <motion.div layoutId="activeTab" className="absolute top-0 left-1/2 -translate-x-1/2 h-1 rounded-full" style={{
            backgroundColor: OPENFINANCE_THEME.colors.primary500,
            width: '32px'
          }} transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-1568" />}

              {/* Icon with Badge */}
              <div className="relative mb-1" data-id="element-1569">
                <motion.div animate={{
              scale: isActive ? 1.1 : 1
            }} transition={{
              duration: 0.2
            }} data-id="element-1570">
                  <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} data-id="element-1571" />
                </motion.div>

                {/* Badge */}
                {tab.badge !== undefined && tab.badge > 0 && <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1 -right-2 min-w-[18px] h-[18px] rounded-full flex items-center justify-center text-[10px] font-bold text-white px-1" style={{
              backgroundColor: OPENFINANCE_THEME.colors.error
            }} data-id="element-1572">
                    {tab.badge > 9 ? '9+' : tab.badge}
                  </motion.div>}
              </div>

              {/* Label */}
              <span className="text-xs font-medium" style={{
            fontFamily: OPENFINANCE_THEME.fonts.body,
            fontWeight: isActive ? 600 : 500
          }} data-id="element-1573">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}